import { PencilSimpleIcon } from '@phosphor-icons/react';
import * as React from 'react';

import { Api } from '../../../api';
import { IconButton, Text } from '../../../components';
import { Color } from '../../../constants';
import EditTitleModal from './EditTitleModal';

type Props = Readonly<{
  ticket: Api.Ticket.V_Detail;
  invalidate: () => unknown;
}>;

export default function TicketTitle({ ticket, invalidate }: Props) {
  const [editing, setEditing] = React.useState(false);

  return (
    <>
      <Text typeface="headline">{ticket.title}</Text>
      <IconButton
        aria-label="Edit ticket title"
        tooltip="Edit title"
        onClick={() => setEditing(true)}
      >
        <PencilSimpleIcon size={20} color={Color.neutral80} />
      </IconButton>
      {editing && (
        <EditTitleModal
          ticket={ticket}
          onClose={() => setEditing(false)}
          invalidate={invalidate}
        />
      )}
    </>
  );
}
